module.exports = __webpack_public_path__ + "static/media/adv-info.4bfc723e.svg";